module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 47
// module chunks = 0